import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-6 mb-xl-9" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex align-items-center mb-1" }
const _hoisted_8 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bold me-3"
}
const _hoisted_9 = { class: "d-flex flex-wrap fw-semibold mb-4 fs-5 text-gray-400" }
const _hoisted_10 = { class: "col-8" }
const _hoisted_11 = { class: "d-flex flex-wrap" }
const _hoisted_12 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "fs-4 fw-bold" }
const _hoisted_15 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "fs-4 fw-bold" }
const _hoisted_18 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "fs-4 fw-bold" }
const _hoisted_21 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_22 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_23 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_24 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_25 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_26 = {
  class: "tab-pane fade show active",
  id: "invoice_details",
  role: "tabpanel"
}
const _hoisted_27 = { class: "card mb-6 mb-xl-9" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_30 = { class: "flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0" }
const _hoisted_31 = { class: "mt-n1" }
const _hoisted_32 = { class: "m-0" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-sm-6 mt-5" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "mb-5 fw-bold fs-6 text-gray-800" }
const _hoisted_38 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_39 = { class: "col-6" }
const _hoisted_40 = { class: "mb-5 fw-bold fs-6 text-gray-800 d-flex align-items-center flex-wrap" }
const _hoisted_41 = { class: "fw-bold fs-6 text-gray-800" }
const _hoisted_42 = { class: "col-sm-6" }
const _hoisted_43 = { class: "row d-print-none border border-dashed border-gray-300 card-rounded h-lg-100 min-w-md-300px p-9 bg-lighten" }
const _hoisted_44 = { class: "col-6" }
const _hoisted_45 = { class: "mb-8" }
const _hoisted_46 = { class: "fs-4 badge badge-light-success me-2" }
const _hoisted_47 = { class: "mb-5" }
const _hoisted_48 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_49 = {
  style: {"margin-left":"5px"},
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_50 = { class: "mb-5" }
const _hoisted_51 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_52 = {
  style: {"margin-left":"5px"},
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_53 = { class: "mb-5" }
const _hoisted_54 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_55 = {
  style: {"margin-left":"5px"},
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_56 = { class: "mb-5" }
const _hoisted_57 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_58 = {
  style: {"margin-left":"5px"},
  class: "fw-bold fs-6 text-gray-800"
}
const _hoisted_59 = { class: "col-6" }
const _hoisted_60 = { class: "mb-5" }
const _hoisted_61 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_62 = {
  style: {"margin-left":"5px"},
  class: "fw-bold text-gray-800 fs-6"
}
const _hoisted_63 = { class: "mb-5" }
const _hoisted_64 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_65 = {
  style: {"margin-left":"5px"},
  class: "fw-bold text-gray-800 fs-6"
}
const _hoisted_66 = { class: "mb-5" }
const _hoisted_67 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_68 = {
  style: {"margin-left":"5px"},
  class: "fw-bold text-gray-800 fs-6"
}
const _hoisted_69 = { class: "mb-5" }
const _hoisted_70 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_71 = {
  style: {"margin-left":"5px"},
  class: "fw-bold text-gray-800 fs-6"
}
const _hoisted_72 = { class: "col-12" }
const _hoisted_73 = { class: "fw-semibold text-gray-600 fs-7" }
const _hoisted_74 = {
  style: {"margin-left":"5px"},
  class: "fw-bold text-gray-800 fs-6"
}
const _hoisted_75 = { class: "flex-grow-1" }
const _hoisted_76 = { class: "table-responsive border-bottom mb-9" }
const _hoisted_77 = { class: "table mb-3" }
const _hoisted_78 = { class: "text-start" }
const _hoisted_79 = { class: "" }
const _hoisted_80 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_81 = {
  class: "tab-pane fade",
  id: "offers",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InvoiceOffers = _resolveComponent("InvoiceOffers")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: `/Vendors/${_ctx.vendor?.Id}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_8, " Issued By: " + _toDisplayString(_ctx.vendor?.Name), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "badge badge-light-success me-auto" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_9, " Note - " + _toDisplayString(_ctx.invoice.Note), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.invoice.Status), 1)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, "Status", -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDate(_ctx.invoice.IssueDate)), 1)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, "Issue Date", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.invoice.DueDate)), 1)
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, "Due Date", -1))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
                  _createElementVNode("div", { class: "fs-4 fw-bold" }, "Total Amount")
                ], -1)),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.currencyFormat(_ctx.invoice.TotalAmount, _ctx.invoice.Currency)), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
                  _createElementVNode("div", { class: "fs-4 fw-bold" }, "Sub Total")
                ], -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.currencyFormat(_ctx.invoice.SubTotal, _ctx.invoice.Currency)), 1)
              ])
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"separator\"></div><ul class=\"nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold\"><li class=\"nav-item\"><a class=\"nav-link text-active-primary active\" data-bs-toggle=\"tab\" href=\"#invoice_details\">Overview</a></li><li class=\"nav-item\"><a class=\"nav-link text-active-primary\" data-bs-toggle=\"tab\" href=\"#offers\">Offers</a></li></ul>", 2))
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Issue Date:", -1)),
                            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.formatDate((_ctx.invoice.IssueDate))), 1),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Issued For:", -1)),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.companyName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Due Date:", -1)),
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDate(_ctx.invoice.DueDate)), 1),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mt-5" }, "Issued By:", -1)),
                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.vendor?.Name), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _cache[15] || (_cache[15] = _createElementVNode("h6", { class: "mb-8 fw-bolder text-gray-600 text-hover-primary" }, "INVOICE DETAILS", -1)),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.invoice.Status), 1)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _cache[11] || (_cache[11] = _createTextVNode(" Sub Total: ", -1)),
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.currencyFormat(_ctx.invoice.SubTotal, _ctx.invoice.Currency)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _cache[12] || (_cache[12] = _createTextVNode(" Tax Amount: ", -1)),
                                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.currencyFormat(_ctx.invoice.TaxAmount, _ctx.invoice.Currency)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _cache[13] || (_cache[13] = _createTextVNode(" Total Amount: ", -1)),
                                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.currencyFormat(_ctx.invoice.TotalAmount, _ctx.invoice.Currency)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _cache[14] || (_cache[14] = _createTextVNode(" Amount Due: ", -1)),
                                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.currencyFormat(_ctx.invoice.AmountDue, _ctx.invoice.Currency)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _cache[20] || (_cache[20] = _createElementVNode("h6", { class: "mb-8 fw-bolder text-gray-600 text-hover-primary" }, "RATE DETAILS", -1)),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _cache[16] || (_cache[16] = _createTextVNode(" Currency: ", -1)),
                                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.invoice.Currency), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _cache[17] || (_cache[17] = _createTextVNode(" Currency Rate: ", -1)),
                                _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.invoice.CurrencyRate), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _cache[18] || (_cache[18] = _createTextVNode(" Tax Rate Name: ", -1)),
                                _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.invoice.TaxRateName), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _cache[19] || (_cache[19] = _createTextVNode(" Tax Rate Percent: ", -1)),
                                _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.invoice.TaxRatePercent), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _cache[21] || (_cache[21] = _createTextVNode(" Note: ", -1)),
                              _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.invoice.Note), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("table", _hoisted_77, [
                          _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", { class: "border-bottom fs-6 fw-bold text-muted" }, [
                              _createElementVNode("th", { class: "pb-2" }, "Description"),
                              _createElementVNode("th", { class: "text-end pb-2" }, "Unit Amount"),
                              _createElementVNode("th", { class: "text-end pb-2" }, "Quantity"),
                              _createElementVNode("th", { class: "text-end pb-2" }, "Sub Total"),
                              _createElementVNode("th", { class: "text-end pb-2" }, "Total Amount"),
                              _createElementVNode("th", { class: "text-end pb-2" }, "Tax Amount")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.InvoiceLineItems, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                class: "fw-bold text-gray-700 fs-5 text-end"
                              }, [
                                _createElementVNode("td", _hoisted_78, _toDisplayString(item.Description), 1),
                                _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.currencyFormat(item.UnitAmount, _ctx.invoice.Currency)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.Quantity), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.currencyFormat(item.SubTotal, _ctx.invoice.Currency)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.currencyFormat(item.TotalAmount, _ctx.invoice.Currency)), 1),
                                _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.currencyFormat(item.TaxAmount, _ctx.invoice.Currency)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_81, [
        _createVNode(_component_InvoiceOffers)
      ])
    ])
  ], 64))
}